module.exports = __webpack_public_path__ + "img/orkney-islands.dcb2a0f8.svg";